export const yearlyQuarterValue = 5;
export const quarters = [1, 2, 3, 4];
export const nameBubbleColors = ['#1ABC9C', '#3498DB', '#9B59B6', '#E67E22', '#E74C3C', '#2ECC71', '#F1C40F', '#16A085', '#34495E', '#7F8C8D'];
export const approval_options = [
    { key: 'rejected', bgColor: 'var(--invalid-input)', icon: 'fa-solid fa-xmark' },
    { key: 'change_requested', bgColor: 'var(--sustainfinity-yellow)', icon: 'fa-solid fa-rotate-left' },
    { key: 'approved', bgColor: 'var(--sustainfinity-green)', icon: 'fa-solid fa-check' },
];